import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "v-card-title" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "d-flex flex-column align-stretch" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MGDialog',
    props: {
        modelValue: { type: Boolean },
        maxWidth: {},
        persistent: { type: Boolean },
        title: {},
        icon: {},
        contentHeight: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const showDialog = computed({
            get() {
                return props.modelValue ?? false;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        const contentStyle = computed(() => ({
            height: props.contentHeight ?? '300px',
            overflowY: 'auto'
        }));
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                modelValue: showDialog.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((showDialog).value = $event)),
                "max-width": _ctx.maxWidth,
                persistent: _ctx.persistent
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card, { class: "d-flex flex-column mg-dialog-card" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "header" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                        (_ctx.icon)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: _ctx.icon,
                                                class: "icon"
                                            }, null, 8, _hoisted_2))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
                                    ])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_text, {
                                style: _normalizeStyle(contentStyle.value)
                            }, {
                                default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "content")
                                ]),
                                _: 3
                            }, 8, ["style"]),
                            _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                        _renderSlot(_ctx.$slots, "actions")
                                    ])
                                ]),
                                _: 3
                            }),
                            _createVNode(_component_v_card_text, { class: "footer" }, {
                                default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "footer")
                                ]),
                                _: 3
                            })
                        ]),
                        _: 3
                    })
                ]),
                _: 3
            }, 8, ["modelValue", "max-width", "persistent"]));
        };
    }
});
